import React from 'react'

const ImageTile = ({imageUrl, photographer, speciesName, onClick}) => {

    let linkPhotographer;
    if (photographer.includes('Public Domain')) {
      linkPhotographer = 'https://creativecommons.org/publicdomain/zero/1.0/'
    } else if (photographer.includes('CC BY')) {
      linkPhotographer = 'https://creativecommons.org/licenses/by/4.0/'
    } else if (photographer.includes('CC BY-NC')) {
      linkPhotographer = 'https://creativecommons.org/licenses/by-nc/4.0/'
    } else if (photographer.includes('CC BY-ND')) {
      linkPhotographer = 'https://creativecommons.org/licenses/by-nd/4.0/'
    } else if (photographer.includes('CC BY-NC-ND')) {
      linkPhotographer = 'https://creativecommons.org/licenses/by-nc-nd/4.0/'
    } else if (photographer.includes('CC BY-SA')) {
      linkPhotographer = 'https://creativecommons.org/licenses/by-sa/4.0/'
    } else if (photographer.includes('CC BY-NC-SA')) {
      linkPhotographer = 'https://creativecommons.org/licenses/by-nc-sa/4.0/'
    }

    return (
      <div className="image-tile-wrapper">
        <div className="image-tile" onClick={onClick}>
          <img src={imageUrl}/>
        </div>
        {(speciesName || photographer) && (
          <div className="image-caption">
            <span className="species-name">{speciesName}</span>
            <span className="attribution">
              <a target={"_blank"} rel="noreferrer" href={linkPhotographer}>{photographer}</a></span>
          </div>
        )}
      </div>
    )
  }
;

export default ImageTile;
